module.exports = __webpack_public_path__ + "assets/img/icon-act-f4ddc616.png";